module.exports = __webpack_public_path__ + "img/osnovne-informacije.479c35bb.png";